// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5a3e316f","453":"5de60045","455":"88d17a97"}[chunkId] + ".chunk.js";
};